import { shortLived, invalidateShortLived } from '../utils/shortLivedCache';
import { getActiveHomeOperationSlots } from './homeOperationSlots';

const CACHE_KEY = 'welcome:operation-slots';
const TTL_MS = 30_000;

/** 欢迎页轮播/专题共用，30s 内多组件只请求一次 */
export function fetchSharedActiveOperationSlots() {
  return shortLived(
    CACHE_KEY,
    () => getActiveHomeOperationSlots(),
    TTL_MS
  );
}

export function invalidateSharedOperationSlots() {
  invalidateShortLived(CACHE_KEY);
}
